import React, { useState, useEffect, useRef } from 'react'
import CountUp from 'react-countup';
import "./CrmCounter.css"

const CrmCounter = () => {
  const [startCounting, setStartCounting] = useState(false)
  const statsRef = useRef(null)  

const formatWithLeadingZero = (value) => {
  const formatted = value < 10 ? `0${value}` : value.toString();
  return formatted + '+';
}

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setStartCounting(true)
        }
      },
      {
        threshold: 0.3, 
        rootMargin: '0px'
      }
    )

    if (statsRef.current) {
      observer.observe(statsRef.current)
    }

    return () => {
      if (statsRef.current) {
        observer.unobserve(statsRef.current)
      }
    }
  }, [])

  return (
    <section id="crmstats" ref={statsRef}>
         <div className="section">
            <div className="container">
                 <h2 className="heading">
             Our CRM Expertise in Numbers
            </h2>
        <div className="containermain">
            <div className="statsBox">
                <span>
        <CountUp 
    start={0} 
    end={startCounting ? 8 : 0} 
    duration={2.5} 
    separator=""
    formattingFn={formatWithLeadingZero}
/>
                </span>
                <p>Years of Experience</p>
                <span className='para'>Building powerful, scalable CRM solutions across industries.</span>
            </div>
            <div className="statsBox">
                <span>
                    <CountUp 
                        start={0} 
                        end={startCounting ? 100 : 0} 
                        duration={2.5} 
                        suffix="+"
                    />
                </span>
                <p>Custom CRM Projects</p>
                 <span className='para'>Delivered with precision, innovation, and measurable impact.</span>
            </div>
            <div className="statsBox">
                <span>
                    <CountUp 
                        start={0} 
                        end={startCounting ? 98 : 0} 
                        duration={2.5} 
                        suffix="+"
                    />
                </span>
                <p>Client Satisfaction Rate</p>
                <span className='para'>Trusted by global businesses for reliability, innovation, and long-term support.</span>
            </div>
                 <div className="statsBox">
                <span>
                    <CountUp 
                        start={0} 
                        end={startCounting ? 60 : 0} 
                        duration={2.5} 
                        suffix="+"
                    />
                </span>
                <p>Successful Projects</p>
                <span className='para'>From startups to enterprises, we’ve built CRM systems that streamline workflows and boost productivity.</span>
            </div>
             <div className="statsBox">
                <span>
                    <CountUp 
                        start={0} 
                        end={startCounting ? 12 : 0} 
                        duration={2.5} 
                        suffix="+"
                    />
                </span>
                <p>Global Client Base</p>
                <span className='para'>Trusted by businesses in 12+ countries for end-to-end CRM excellence.</span>
            </div>
          </div>
            </div>
         </div>
    </section>
  )
}

export default CrmCounter;